module.exports = __webpack_public_path__ + "static/media/add-white.3b1617f5.svg";